module.exports = {
  localeName: 'en-US',
  momentFormat: 'DD/MM/YYYY'
};
